import * as React from "react";
const SvgFiBrandsFedex = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#151A2D"
      d="M23.852 14.46c0-.368-.262-.64-.624-.64-.361 0-.624.272-.624.64 0 .37.263.64.624.64.362 0 .624-.27.624-.64m-.787.034v.419h-.135v-.923h.336c.197 0 .287.086.287.254 0 .103-.07.185-.16.197v.004c.078.012.107.082.123.209.012.082.029.226.058.258h-.16c-.037-.086-.033-.21-.062-.312-.024-.078-.065-.107-.155-.107h-.132m.168-.12c.131 0 .168-.07.168-.13 0-.074-.037-.131-.168-.131h-.168v.262zm-.776.087c0-.455.362-.763.771-.763s.771.308.771.763a.756.756 0 0 1-.771.763.756.756 0 0 1-.771-.763M19.785 15.092l-.89-.998-.881.998H16.16l1.812-2.037-1.812-2.036h1.912l.897.989.865-.989h1.845l-1.804 2.028 1.829 2.045z"
    />
    <path
      fill="#151A2D"
      d="M16.161 10.106V8.675h-5.063V11.3h-.018c-.332-.382-.748-.515-1.23-.515-.988 0-1.732.672-1.993 1.559-.298-.978-1.066-1.577-2.205-1.577-.925 0-1.655.415-2.037 1.092v-.841H1.704v-.913H3.79V8.675H0v6.416h1.704v-2.697h1.699q-.077.298-.078.634c0 1.339 1.022 2.278 2.327 2.278 1.097 0 1.82-.515 2.203-1.455h-1.46c-.197.283-.347.366-.742.366-.458 0-.853-.4-.853-.873h2.974c.129 1.063.957 1.98 2.093 1.98.49 0 .939-.241 1.213-.648h.017v.415h5.063v-1.434h-2.053v-1.263h2.053v-1.376h-2.053v-.913h2.054M4.847 12.414c.095-.407.411-.674.805-.674.435 0 .735.258.813.674zm5.338 1.7c-.554 0-.898-.515-.898-1.054 0-.576.3-1.13.898-1.13.621 0 .868.554.868 1.13 0 .546-.262 1.055-.868 1.055"
    />
  </svg>
);
export default SvgFiBrandsFedex;
